import React, { useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { Marquee } from "./components/landing/Marquee";
import { HowItWorks } from "./components/landing/HowItWorks";
import { Timeline } from "./components/landing/Timeline";
import { MounjaroSpotlight } from "./components/landing/MounjaroSpotlight";
import { GetStarted } from "./components/landing/GetStarted";
import { DoctorProfile } from "./components/landing/DoctorProfile";
import { Services } from "./components/landing/Services";
import { ServiceArea } from "./components/landing/ServiceArea";
import { Testimonials } from "./components/landing/Testimonials";
import { BookingForm } from "./components/landing/BookingForm";
import { FAQ } from "./components/landing/FAQ";
import { Footer } from "./components/landing/Footer";
import { FloatingWhatsApp } from "./components/landing/FloatingWhatsApp";
import { BMIQuiz } from "./components/landing/BMIQuiz";

function Landing() {
  const formRef = useRef(null);
  const [quizOpen, setQuizOpen] = useState(false);
  const openQuiz = () => setQuizOpen(true);
  const scrollToForm = () => {
    if (formRef.current) formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="App bg-white text-[#242220]">
      <Header onBookClick={openQuiz} />
      <main>
        <Hero onBookClick={openQuiz} onSecondaryClick={scrollToForm} />
        <Marquee />
        <HowItWorks />
        <Timeline />
        <MounjaroSpotlight onBookClick={openQuiz} />
        <Services />
        <GetStarted onBookClick={openQuiz} />
        <DoctorProfile />
        <ServiceArea />
        <Testimonials />
        <BookingForm ref={formRef} />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <BMIQuiz open={quizOpen} onOpenChange={setQuizOpen} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
